import scrollEvent from './scrollEvent'
// 图片懒加载
export default function Lazy (opt) {
  this.parent = opt.parent
  this.imgs = null
  this.init()
}
Lazy.prototype = {
  init: function () {
    let k = this
    k.getImgs()
    k.lazyEvent()
    setTimeout(function () {
      k.loadImgs()
    })
  },
  reset: function () {
    let k = this
    k.getImgs()
  },
  getImgs: function () {
    let k = this
    let arr = []
    let imgs = k.parent.querySelectorAll('img')
    Array.prototype.forEach.call(imgs, function (e, i) {
      let src = e.getAttribute('data-src')
      if (src) {
        arr.push(e)
      }
    })
    k.imgs = arr
  },
  lazyEvent: function () {
    let k = this
    scrollEvent(function () {
      k.loadImgs.call(k)
    })
  },
  loadImgs: function () {
    let k = this
    let len = k.imgs.length
    if (len === 0) {
      return
    }
    var wh = window.innerHeight
    var stop = window.pageYOffset
    var curH = stop + wh
    var cur, pos
    for (let i = 0; i < len; i++) {
      cur = k.imgs[i]
      pos = k.offset(cur)
      if (pos <= curH) {
        let trueSrc = cur.getAttribute('data-src')
        cur.setAttribute('src', trueSrc)
        cur.removeAttribute('data-src')
      }
    }
    k.getImgs()
  },
  offset: function (e) {
    let t = e.offsetTop
    while (e = e.offsetParent) {
      t += e.offsetTop
    }
    return t
  }
}



// WEBPACK FOOTER //
// ./src/api/utils/lazyLoad.js